import { toHTML } from "@portabletext/to-html";
import type {
  Product,
  SubscriptionOption,
} from "@bluebottlecoffee/design-system/components/lib/types";
import { ConversionProps } from "@bluebottlecoffee/design-system";
import { toImageResponsiveProps } from "./image";
import { Product as ProductSchema, SanityKeyed } from "../sanity-schema";
import { toVariantProps } from "./variant";
import { DereferencedVariant } from "../sanity/variant-queries";

export type ConversionSchema = Omit<
  ProductSchema,
  "variants" | "subscription" | "subscriptionOptions"
> & {
  variants: DereferencedVariant[];
  subscription: Product["subscription"];
  subscriptionOptions: SanityKeyed<SubscriptionOption>[];
};

export function toProductProps(
  {
    slug,
    name,
    subscription,
    subscriptionOptions,
    variants,
    description,
    images,
    subscriptionType,
  }: ConversionSchema,
  lang: string,
): Product {
  return {
    description: toHTML(description[lang]),
    images: images.map((i) => toImageResponsiveProps(i, lang)),
    name: name[lang],
    slug: slug.current,
    subscription,
    subscriptionOptions: subscriptionOptions?.map((subscriptionOption) => {
      // subscriptionOptions are Sanity objects, which do not have _id's :(
      // so mapping _key to component expected type _id
      // rather than refactoring the world rn
      const { _key, ...rest } = subscriptionOption;
      return { ...rest, _id: _key };
    }),
    subscriptionType,
    variants: variants
      .filter((v) => v.forSale)
      .map((v) => toVariantProps(v, lang)),
  };
}

export function toConversionProps(
  data: ConversionSchema,
  lang: string,
): Omit<
  ConversionProps,
  | "addToCart"
  | "createStockRequest"
  | "subscribeProduct"
  | "useVariantAvailability"
> {
  return {
    product: toProductProps(data, lang),
    // quantityGuide?: QuantityGuideProps,
    // ...(data.)showQuantityGuide?: boolean,
    // staticShippingCopy?: string,
    // nextRoast?: NextRoastProps
  };
}
